import { Injectable, OnDestroy } from "@angular/core";
import { InspectionReport } from "../_objects/inspection-report";
import { Observable, Subject as RxjsSubject } from "rxjs";
import { Inspection } from "../_objects/inspection";

export class CommonLayoutTitleWrapper {
  inspectionReport: InspectionReport;
  inspection: Inspection;

  constructor() {}
}

@Injectable({
  providedIn: "root"
})
export class CommonLayoutService implements OnDestroy {
  // Title Wrapper
  private onCommonLayoutTitleWrapper$ = new RxjsSubject<CommonLayoutTitleWrapper>();
  private onCommonLayoutNewInspection$ = new RxjsSubject<any>();
  private onCommonLayoutNewMark$ = new RxjsSubject<boolean>();
  private onCommonLayoutNewTitle$ = new RxjsSubject<boolean>();
  private onCommonLayoutNewTag$ = new RxjsSubject<boolean>();

  ngOnDestroy(): void {
    this.onCommonLayoutTitleWrapper$.unsubscribe();
    this.onCommonLayoutNewInspection$.unsubscribe();
    this.onCommonLayoutNewMark$.unsubscribe();
    this.onCommonLayoutNewTitle$.unsubscribe();
    this.onCommonLayoutNewTag$.unsubscribe();
  }

  commonLayoutTitleWrapperObs(): Observable<CommonLayoutTitleWrapper> {
    return this.onCommonLayoutTitleWrapper$;
  }

  commonLayoutAddInspectionObs(): Observable<any> {
    return this.onCommonLayoutNewInspection$;
  }

  commonLayoutNewMarkObs(): Observable<boolean> {
    return this.onCommonLayoutNewMark$;
  }

  commonLayoutNewTitleObs(): Observable<boolean> {
    return this.onCommonLayoutNewTitle$;
  }

  commonLayoutNewTagObs(): Observable<boolean> {
    return this.onCommonLayoutNewTag$;
  }

  commonLayoutTitleWrapperEmit(inspection: Inspection, inspectionReport: InspectionReport = null) {
    const wrapper = new CommonLayoutTitleWrapper();
    wrapper.inspection = inspection;
    wrapper.inspectionReport = inspectionReport;
    this.onCommonLayoutTitleWrapper$.next(wrapper);
  }

  commonLayoutNewInspectionEmit() {
    this.onCommonLayoutNewInspection$.next(undefined);
  }

  commonLayoutNewMarkEmit(isDisabledNewButton: boolean) {
    this.onCommonLayoutNewMark$.next(isDisabledNewButton);
  }

  commonLayoutNewTitleEmit(isDisabledNewButton: boolean) {
    this.onCommonLayoutNewTitle$.next(isDisabledNewButton);
  }
  commonLayoutNewTagEmit(isDisabledNewButton: boolean) {
    this.onCommonLayoutNewTag$.next(isDisabledNewButton);
  }
}
